module.exports = __webpack_public_path__ + "img/maneken_pos_5_back.9f71989e.png";